import styled from '@emotion/styled';
import Header from './Header';
import { useContext, useEffect } from 'react';
import { ListsContext, ListsProvider } from 'src/services/contextProviders/lists/listsContext';
import { getLists } from 'src/services/contextProviders/lists/listsApiCall';
import AdminSidebar from 'src/containers/admin/AdminSidebar';
import { useState } from 'react';
import authService from 'src/services/api/auth';
import { screenSizes } from 'src/assets/styles/Literals';
import { appShellStyles } from 'src/assets/styles/Layout';

const AppLayoutContainer = styled.section`
  ${appShellStyles}
  @import '@fortawesome/fontawesome-free/css/all.css';
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  ${(p) =>
    p.fullScreen &&
    `
    height: 100vh;
    overflow: hidden;
  `}
`;

const MainContent = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

const Layout = ({ children, fullScreen = false }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const {
    set_churchMinistries,
    set_experienceVolunteersRoles,
    set_experienceVolunteersSections,
    set_groupCategories,
    set_leaderCategories,
    set_data,
  } = useContext(ListsContext);
  const currentUser = authService.getCurrentUser();

  useEffect(() => {
    getLists({
      set_churchMinistries,
      set_experienceVolunteersRoles,
      set_experienceVolunteersSections,
      set_groupCategories,
      set_leaderCategories,
      set_data,
    });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > screenSizes.tablet) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (window.location.search.includes('admin=open')) {
      setSidebarOpen(true);
      window.history.replaceState({}, '', '/');
    }
  }, [window.location.search]);

  return (
    <AppLayoutContainer fullScreen={fullScreen}>
      {currentUser.profile === 1 && (
        <AdminSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
      )}
      {!fullScreen && <Header />}
      <MainContent>{children}</MainContent>
    </AppLayoutContainer>
  );
};

const LayoutWithProvider = (props) => {
  return (
    <ListsProvider>
      <Layout {...props} />
    </ListsProvider>
  );
};

export default LayoutWithProvider;
